<template>
  <div>
    <div class="filters-bg" @click="$emit('closeFilters')"></div>
    <transition name="fade">
      <div class="panel filters-panel" v-if="currentTab === 1">
        <div class="panel-head">
          <div class="panel-title">
            Filters
          </div>
          <button class="btn-link btn-colored reset-filters-btn" @click="resetFilters">
            RESET ALL
          </button>
          <button class="btn-link categories-close m-0" @click="$emit('closeFilters')">
          </button>
        </div>
      <div class="panel-body">
        <button class="categories-btn" @click="currentTab = 2">
          Categories
          <img src="../assets/img/eva_arrow-ios-forward-outline-left.svg" alt="forward" class="flip-x">
        </button>
        <div v-if="!isWideScreen">
          <div class="filters-category">
            <div class="filters-category-head">
              Cashback
            </div>
            <div class="filters-category-body">
              <label class="filter-label" v-for="item in cashbackFilters" :key="item.val">
                <input type="radio" name="discount-filter" :value="item.val"
                       v-model="filters.cashbackValue"
                       @change="changeCashbackFilter"
                       :checked="filters.cashbackValue === item.val">
                <span class="filter-radio">
                {{item.title}}
              </span>
              </label>
            </div>
          </div>
          <div class="filters-category">
            <div class="filters-category-head">
              Coupons
            </div>
            <div class="filters-category-body">
              <label class="filter-label" v-for="item in couponsFilters" :key="item.val">
                <input type="radio" name="coupons-filter" :value="item.val"
                       v-model="filters.couponsFilter"
                       @change="changeCouponsFilter"
                       :checked="filters.couponsFilter === item.val">
                <span class="filter-radio">
                {{item.title}}
              </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    </transition>
    <transition name="fade">
      <div class="panel filters-panel" v-if="currentTab === 2">
        <div class="filters-loader" v-if="isLoading">
          <div class="lds-dual-ring"></div>
        </div>
        <div v-if="isWideScreen">
          <div class="panel-head">
            <div class="panel-title">
              Filters
            </div>
            <button class="btn-link btn-colored reset-filters-btn" @click="resetFilters">
              RESET ALL
            </button>
            <button class="btn-link categories-close m-0" @click="$emit('closeFilters')">
            </button>
          </div>
          <div class="panel-sub-header">
            <div class="panel-title">
              Categories
            </div>
          </div>
        </div>
        <div class="panel-head" v-else>
          <button class="btn-link">
            <img src="../assets/img/eva_arrow-ios-forward-outline-left.svg" alt="forward left" @click="currentTab = 1">
          </button>
          <div class="panel-title">
            Categories
          </div>
          <button class="btn-link categories-close" @click="$emit('closeFilters')">
          </button>
        </div>
        <div class="panel-body" :class="{'panel-body-wide': isWideScreen}">
          <div class="categories-item main"
               :class="{active: activeCategoryID === 'all'}"
               @click="chooseCategory('all')">
            All categories
            <img src="../assets/img/eva_arrow-ios-forward-outline-left.svg" alt="forward" class="flip-x">
          </div>
          <div class="categories-item main"
               :class="{active: activeCategoryID === item.id}"
               v-for="item in categories"
               :key="item.id"
               @click="showSubCategories(item)">
            {{item.name}}
            <img src="../assets/img/eva_arrow-ios-forward-outline-left.svg" alt="forward" class="flip-x">
          </div>
        </div>
        <div v-if="isWideScreen">
          <div class="filters-divider"></div>
          <div class="filters-category">
            <div class="filters-category-head">
              Cashback
            </div>
            <div class="filters-category-body">
              <label class="filter-label" v-for="item in cashbackFilters" :key="item.val">
                <input type="radio" name="discount-filter" :value="item.val"
                       v-model="filters.cashbackValue"
                       @change="changeCashbackFilter"
                       :checked="filters.cashbackValue === item.val">
                <span class="filter-radio">
                {{item.title}}
              </span>
              </label>
            </div>
          </div>
          <div class="filters-category">
            <div class="filters-category-head">
              Coupons
            </div>
            <div class="filters-category-body">
              <label class="filter-label" v-for="item in couponsFilters" :key="item.val">
                <input type="radio" name="coupons-filter" :value="item.val"
                       v-model="filters.couponsFilter"
                       @change="changeCouponsFilter"
                       :checked="filters.couponsFilter === item.val">
                <span class="filter-radio">
                {{item.title}}
              </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="panel filters-panel" v-if="currentTab === 3">
        <div class="filters-loader" v-if="isLoading">
          <div class="lds-dual-ring"></div>
        </div>
        <div class="panel-head">
          <button class="btn-link">
            <img src="../assets/img/eva_arrow-ios-forward-outline-left.svg" alt="forward left" @click="currentTab = 2; activeSubCategoryID = null">
          </button>
          <div class="panel-title">
            <span @click="currentTab = 2; activeSubCategoryID = null" class="pointer">{{activeCategoryName}}</span>
            <span v-if="activeSubCategoryName !=''">-</span> {{activeSubCategoryName}}
          </div>
          <button class="btn-link categories-close" @click="$emit('closeFilters')"></button>
        </div>
        <div>
          <span v-if="subCategoriesComputed && subCategoriesComputed.length === 0">No Subcategories</span>
          <div class="panel-body" :class="{'panel-body-wide': isWideScreen}" v-else>
            <div class="categories-item main"
                  :class="{active: activeSubCategoryID === 'all'}"
                  @click="chooseSubCategory('all')">
              All subcategories
            </div>
            <div class="categories-item main"
                 :class="{active: activeSubCategoryID === item.id}"
                 v-for="item in subCategoriesComputed"
                 :key="item.id"
                 @click="chooseSubCategory(item)">
              {{item.name}}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {performRequest} from "@/api";
import {MAIN_API_URL, reportEvent} from "@/utils";

export default {
  name: 'Filters',
  props: ['couponsFilter', 'cashbackValue', 'categories', 'activeCategory', 'activeSubCategory', 'isWideScreen'],
  emits: ['closeFilters', 'changeFilters'],
  data() {
    return {
      subCategories: null,
      isLoading: false,
      cashbackFilters:[
        {
          title: 'up to 3%',
          val: 3,
        },
        {
          title: 'up to 5%',
          val: 5,
        },
        {
          title: 'up to 10%',
          val: 10,
        },
        {
          title: 'All',
          val: 'all',
        }
      ],
      couponsFilters:[
        {
          title: 'Just with coupons',
          val: 'with',
        },
        {
          title: 'Without coupons',
          val: 'without',
        },
        {
          title: 'All',
          val: 'all',
        },
      ],
      currentTab: this.activeSubCategory && this.activeSubCategory != 'all' ? 3 : this.isWideScreen ? 2 : 1,
      activeCategoryID: this.activeCategory,
      activeSubCategoryID: this.activeSubCategory,
      filters: {
        activeCategory: this.activeCategoryID,
        activeSubCategories: [],
        couponsFilter: this.couponsFilter,
        cashbackValue: this.cashbackValue,
      }

    }
  },
  mounted() {
    console.log(this.activeCategory, this.activeSubCategory);

    if(!this.subCategories){
      performRequest(
          MAIN_API_URL + 'get_sub_categories',
          {
            method: 'POST'
          }
      ).then(res => {
        this.subCategories = res.data.sub_categories;
      })
    }
  },
  computed: {
    subCategoriesComputed () {
      return this.subCategories ? this.subCategories.filter(item => item.category_id === this.activeCategoryID) : null;
    },
    activeCategoryName(){
      const catFound = this.categories.find(item => item.id === this.activeCategoryID)

      return catFound ? catFound.name : ''
    },
    activeSubCategoryName(){
      if(this.subCategories){
        const subCatFound = this.subCategories.find(item => item.id === this.activeSubCategoryID)
        return subCatFound ? subCatFound.name : ''
      } else {
        return ''
      }
    }
  },
  methods: {
    changeCashbackFilter(){
      this.$emit('changeFilters', this.filters)
      reportEvent('filter', {
        action: 'cashback',
        key: this.filters.cashbackValue === 'all' ? 'all' : `up to ${this.filters.cashbackValue}%`
      })

    },
    changeCouponsFilter(){
      this.$emit('changeFilters', this.filters)
      reportEvent('filter', {
        action: 'coupons',
        key: this.filters.couponsFilter
      })

    },
    showSubCategories(item){
      if (item !== 'all'){
        this.isLoading = true
        const $this = this
        setTimeout(function (){
          $this.currentTab = 3
          $this.isLoading = false
        }, 500)
        // this.activeCategoryName = item.name
      }
      this.chooseCategory(item)
    },
    chooseCategory(item){
      console.log(item);
      if(item === 'all'){
        this.activeCategoryID = 'all'
        this.subCategories.forEach(item => this.filters.activeSubCategories.push(item.id))
        this.$emit('closeFilters')
        this.filters.activeCategory = this.activeCategoryID
      } else {
        this.activeCategoryID = item.id
        this.filters.activeCategory = item.id
        this.subCategories.filter(sub => sub.category_id === item.id).forEach(item => {
          this.filters.activeSubCategories.push(item.id)
        })
      }
      console.log(this.filters);
      this.$emit('changeFilters', this.filters)

    },
    chooseSubCategory(item){
      if (item === 'all'){
        this.activeSubCategoryID = 'all'
        this.filters.activeSubCategory = 'all'
        this.subCategories.filter(sub => sub.category_id === this.activeCategoryID).forEach(item => {
          this.filters.activeSubCategories.push(item.id)
        })
        reportEvent('filter', {
          action: 'category',
          key: 'all'
        })
      } else {
        this.activeSubCategoryID = item.id
        this.filters.activeSubCategory = this.activeSubCategoryID
        this.filters.activeSubCategories = [item.id]
        reportEvent('filter', {
          action: 'category',
          key: this.filters.activeSubCategories
        })
      }
      this.$emit('changeFilters', this.filters, this.activeCategoryName, this.activeSubCategoryName)
      this.isLoading = true
      const $this = this
      setTimeout(function (){
        $this.$emit('closeFilters')
        $this.isLoading = false
      }, 500)

    },
    resetFilters(){
      console.log(121231);
      this.filters = {
        activeSubCategories: [],
        cashbackValue: 'all',
        couponsFilter: 'all',
      }
      this.$emit('changeFilters', this.filters)
      this.$emit('closeFilters')
    }
  }
}
</script>

<style lang="scss">
.filters-divider {
  border-bottom: 1px solid rgba(81, 78, 104, 0.1);
  margin: 18px 0;
}
.panel {
  padding: 16px 19px;
  background: #FFFFFF;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 16px 16px 0 0;
  display: flex;
  flex-direction: column;
}

.panel-title {
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #514E68;
}

.panel-head {
  display: flex;
  align-items: center;
  min-height: 38px;
  border-bottom: 1px solid rgba(81, 78, 104, 0.1);
  margin-bottom: 18px;
  flex: 0;
}

.panel-sub-header {
  margin-bottom: 20px;
}

.panel-body {
  flex: 1;
  overflow: auto;
}

.panel-body-wide {
  display: flex;
  flex-wrap: wrap;

  .categories-item {
    width: 25%;
    padding-right: 25px;
    white-space: normal;
  }
}

.reset-filters-btn {
  margin: 0 15px 0 auto;
  font-weight: bold;
  position: relative;
  transition: all 0.3s;
  
  &:after {
    content: "";
    display: block;
    width: 0;
    height: 1px;
    background: #00C6A2;
    position: absolute;
    bottom: -2px;
    left: 6px;
    opacity: 0;
    transition: all 0.3s;
  }
  
  
  &:hover:after {
    opacity: 1;
    width: 70%;
  }
}

.categories-btn {
  padding: 8px 4px 8px 16px;
  background: rgba(81, 78, 104, 0.04);
  border-radius: 8px;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0;
  color: #514E68;
  font-size: 14px;
  margin-bottom: 28px;
}

.filters-category-head {
  font-size: 14px;
  line-height: 17px;
  font-weight: bold;
  margin-bottom: 14px;
}

.filters-category-body {
  display: flex;
  margin-bottom: 24px;
}

.filters-panel {
  position: absolute;
  right: 8px;
  left: 8px;
  top: 116px;
  bottom: 0;
  z-index: 5;
}

.filters-bg {
  content: "";
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  background: rgba(0,0,0,0.1);
}

.filters-loader {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  background: #fff;
  opacity: 0.5;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media all and (min-width: 500px){
  .filters-panel {
    max-width: 344px;
  }
}
.filter-label {
  display: block;
  cursor: pointer;

  input {
    display: none;
  }

  .filter-radio {
    padding: 7px 8px;
    font-weight: bold;
    font-size: 12px;
    line-height: 15px;
    background: #F8F8F9;
    border-radius: 4px;
    display: block;
    transition: all 0.3s;

    &:hover {
      background: #EDEDF6;
    }
  }
  
  input:checked {
    & + {
      .filter-radio {
        color: #4B2EFF;
        background: rgba(75, 46, 255, 0.08);
      }
    }
  }

  & + & {
    margin-left: 6px;
  }
}

.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #00b292;
  border-color: #00b292 transparent #00b292 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media all and (min-width: 1100px){
  .filters-panel {
    max-width: 1100px;
    top: 348px;
    bottom: auto;
    border-radius: 16px;
  }
}

</style>
